module.exports = __webpack_public_path__ + "static/media/whiteCloseIcon.88da5d87.svg";